export const isNumber = (v) => Number.isFinite(v)
export const isObject = (obj) => obj && typeof obj === 'object'
